import { forwardRef } from "react"
import { useTheme } from "@mui/material/styles"
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography
} from "@mui/material"

const headerSX = {
    p: 2.5,
    "& .MuiCardHeader-action": { m: "0px auto", alignSelf: "center" }
}

const MainCard = forwardRef(
    (
        {
            border = true,
            boxShadow = true,
            children,
            subheader,
            content = true,
            contentSX = {},
            darkTitle,
            divider = true,
            elevation,
            secondary,
            shadow,
            sx = {},
            title,
            codeHighlight = false,
            codeString,
            modal = false,
            ...others
        },
        ref
    ) => {
        const theme = useTheme()


        return (
            <Card
                aria-label='main-card'
                elevation={elevation || 0}
                ref={ref}
                {...others}
                sx={{
                    position: "relative",
                    border: border ? "1px solid" : "none",
                    borderRadius: 1.5,
                    borderColor: theme.palette.divider,
                  
                    ...sx
                }}
            >


                {title && <CardHeader
                    sx={headerSX}
                    titleTypographyProps={{ variant: "subtitle1" }}
                    title={title}
                    action={secondary}
                    subheader={subheader}
                />}
                {title && divider && <Divider />}
                {content && <CardContent sx={contentSX}>{children}</CardContent>}
                {!content && children}
            </Card>
        )
    }
)

export default MainCard
